
import { defineComponent } from 'vue';
import { useStepperNavigation } from '@/components/wizard/stepper';
import Button, { ButtonType } from '@/components/Button.vue';
import ProgressBar from '@/components/ProgressBar.vue';

export default defineComponent({
  name: 'WizardNavigation',
  props: {
    allowNext: {
      type: Boolean,
      default: true,
    },
    eventOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Button,
    ProgressBar,
  },
  methods: {
    next() {
      this.$emit('next');
      if (!this.eventOnly) {
        this.nextStep();
      }
    },
    prev() {
      this.$emit('prev');
      if (!this.eventOnly) {
        this.prevStep();
      }
    },
  },
  computed: {
    canNext(): boolean {
      // Can't go anywhere if we are the last step
      if (this.currentStep === this.maxStep) return false;

      // If allowNext is set, obey that with an open default
      return this.allowNext;
    },

    nextText(): string {
      // Indicate final step using the text on the button
      return (this.currentStep === this.maxStep - 1) ? 'Resultaat' : 'Verder';
    },
  },
  data() {
    return {
      ButtonType,
    };
  },
  setup() {
    const nav = useStepperNavigation();

    return {
      ...nav,
    };
  },
});
